import { Type } from "@sinclair/typebox";
import { ActiveActions } from "./integrations/appsActions/ActiveActions";
export const AppsNames = Type.Union([
  Type.Literal("salesforce"),
  Type.Literal("zoom"),
  Type.Literal("teams"),
  Type.Literal("google"),
  Type.Literal("docusign"),
  Type.Literal("outlook"),
  Type.Literal("msdynamics"),
  Type.Literal("hubspot"),
  Type.Literal("microsoft"),
  Type.Literal("hubspotIntegration"),
  Type.Literal("pipedrive"),
  Type.Literal("slack"),
  Type.Literal("tuvisTeamsApp"),
]);
export type AppsWithMoreInfoType = "zoom" | "teams" | "google" | "docusign" | "outlook";
export type AppsWithLogin = AppsWithMoreInfoType | "hubspotIntegration" | "pipedrive" | "slack";

export type AppsNamesType = keyof ActiveActions;
